module.exports = __webpack_public_path__ + "static/media/new_list_white.b019c0d1.png";